import { RepuestosDTO } from "@/application/dto/repuesto/RepuestosDTO";
import { CreateRepuestosDTO } from '@/application/dto/repuesto/CreateRepuestosDTO';
import { ChangeRepuestosDTO } from '@/application/dto/repuesto/ChangeRepuestosDTO';
import { IHttpClient } from "@/application/ports/IHttpClient";
import { Repuesto } from "@/domain/entities/repuesto";
import { API_ENDPOINTS } from "../config/api.config";
import { IRepuestoRepository } from "@/domain/repositories/IRepuestoRepository";

export class RepuestosRepository
    implements IRepuestoRepository {

    constructor(
        private readonly httpClient: IHttpClient
    ) { }


        async findById(
            id: string
        ): Promise<Repuesto[]> {
            const response = await this.httpClient.get<RepuestosDTO[]>(
                API_ENDPOINTS.repuesto.byId(id)
            );

            return response.data.map(dto => this.mapToEntity(dto));
        }
    async create(
        data: CreateRepuestosDTO
    ): Promise<void> {
        await this.httpClient.post<unknown>(
            API_ENDPOINTS.repuesto.base,
            data
        );
    }

    async change(id: string, data: ChangeRepuestosDTO): Promise<void> {
        await this.httpClient.patch<unknown>(
            API_ENDPOINTS.repuesto.byId(id),
            { estado: data.estado }
        );
    }

    update(_id: string, _repuesto: Partial<Repuesto>): Promise<Repuesto> {
        throw new Error("Method not implemented.");
    }




    async findAll(
    ): Promise<Repuesto[]> {

        const response =
            await this.httpClient.get<
                RepuestosDTO[]
            >(
                API_ENDPOINTS.repuesto.base
            );
        console.log(response);

        return response.data.map(dto =>
            this.mapToEntity(dto)
        );
    }

    private mapToEntity(
        dto: RepuestosDTO
    ): Repuesto {

        return {
            id: dto.id,
            nombre: dto.nombre,
            cantidad: dto.cantidad,
            fecha: dto.fecha,
            usuario: dto.usuario,
            destino: dto.destino,
            estado: dto.estado
        };
    }
}
